import React from "react";
import Divider from "@material-ui/core/Divider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import Switch from "@material-ui/core/Switch";
import BrokenImageIcon from "@material-ui/icons/BrokenImage";

import {Link as RouterLink} from "react-router-dom";
import Button from "../mkr/components/Button";

import {Brand} from "../Brand";
import {ChatData, ConfSubscriber, stageClient} from "../logic/StageClient";
import {ChatIcon} from "./ChatIcon";
import {ListItemButtonAbsoluteLink, ListItemButtonRouterLink} from "./ListItemLink";
import {clearSomePersistedState, DefaultValues, hasClosedDescriptions, LocalStorageKeys, usePersistedState} from "../logic/Persistence";
import {makeStyles} from "@material-ui/core/styles";


const useLocalStyles = makeStyles(() => ({
  drawerList: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  drawerSubheaders: {
    backgroundColor: '#ffffffA0',
  },
}));


export function DrawerItems(/*props*/) {
  const classes = useLocalStyles();

  // sub/unsub to global Chats changes
  const [chats, setChats] = React.useState<ChatData[]>([]);
  const [soundOn, setSoundOn] = usePersistedState(LocalStorageKeys.notification_sound, DefaultValues.notification_sound);
  React.useEffect(() => {
    const subscriber: ConfSubscriber = {
      // note: filter to remove chatData that hasn't been detailed by the server yet (created by /chat/url)
      onConf: chats => setChats(chats.filter(chatData => chatData.chatSnapshot)),
    }
    stageClient.subscribeToConf(subscriber);
    return () => stageClient.unsubscribeFromConf(subscriber);
  }, []);

  // decide whether to show some descriptions
  const resetDescriptions = hasClosedDescriptions();

  return (
    <List className={classes.drawerList}>
      {/* Home */}
      <ListItem button component={RouterLink} to='/'>
        {/*
        // @ts-ignore */}
        <Button color="rose" simple variant="contained" fullWidth={true}>
          {Brand.appName}
        </Button>
      </ListItem>

      {/* Chats */}
      <Divider/>
      <ListSubheader className={classes.drawerSubheaders}>
        {Brand.chatsListTitle}
      </ListSubheader>
      {chats.length > 0 && chats.map(chatData => chatData.chatSnapshot &&
        <ListItem button key={chatData.chatId} component={RouterLink} to={'/chat/' + chatData.chatId}>
          <ListItemIcon><ChatIcon chatSnapshot={chatData.chatSnapshot}/></ListItemIcon>
          <ListItemText primary={chatData.chatSnapshot.topic}/>
        </ListItem>)}
      {chats.length === 0 && <ListItem>
        <ListItemIcon><BrokenImageIcon/></ListItemIcon>
        <ListItemText primary='No chat rooms.'/>
      </ListItem>}

      {/* Others... */}
      <Divider/>
      <ListSubheader className={classes.drawerSubheaders}>
        Settings
      </ListSubheader>
      {/*<ListItem button>*/}
      {/*  <ListItemIcon><PeopleIcon/></ListItemIcon>*/}
      {/*  <Button variant="outlined" color="rose" component={RouterLink} to="/chat/new" disabled={true}*/}
      {/*          className={classes.drawerFullButton}>PVT Chat (future)</Button>*/}
      {/*</ListItem>*/}
      {/*<ListSubheader>Dig deeper</ListSubheader>*/}
      {/*<ListItem button>*/}
      {/*  <Button variant="contained" color="rose" component={RouterLink} to='/replica'*/}
      {/*          className={classes.drawerFullButton}>Replicate Yourself</Button>*/}
      {/*</ListItem>*/}
      {/*<ListItemButtonRouterLink primary={`How does this work?`} to="/about"/>*/}
      <ListItem button>
        <FormControlLabel
          control={<Switch checked={soundOn} onChange={e => setSoundOn(e.target.checked)} name="Sound On"/>}
          label="Chat sounds"
        />
      </ListItem>
      {resetDescriptions &&
      <ListItem button onClick={() => {
        clearSomePersistedState();
        window.location.reload();
      }}>
        <ListItemText primary='Show descriptions again'/>
      </ListItem>}
      <Divider/>
      <ListSubheader className={classes.drawerSubheaders}>
        More Info
      </ListSubheader>
      <ListItemButtonRouterLink primary={`About ${Brand.appName}`} to="/about"/>
      <ListItemButtonAbsoluteLink primary={'Blog'} to={Brand.appBlogLink}/>
      <ListItemButtonAbsoluteLink primary={Brand.parentBrandName} to={Brand.parentBrandWebsite}/>
    </List>
  );
}
